<template>
  <CustomersList />
</template>

<script>
import CustomersList from "@/components/customers/CustomersList.vue";

export default {
  name: "CustomerList",
  components: {
    CustomersList
  }
};
</script>

<style></style>
